import Vue from 'vue'

const stringUtil = {
  /**
   * 字符串去除所有空格的方法
   * @param {String} str 需处理字符串
   */
  trim: function (str) {
    str = str || ''
    return str.replace(/(^\s*)|(\s*$)/g, '')
  },

  /**
   * 加密
   * @param {String} input 需加密字符串
   */
  encode64 (input) {
    let keyStr = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' + 'wxyz0123456789+/' + '='
    let output = ''
    let chr1
    let chr2
    let chr3
    let enc1
    let enc2
    let enc3
    let enc4
    let i = 0
    do {
      chr1 = input.charCodeAt(i++)
      chr2 = input.charCodeAt(i++)
      chr3 = input.charCodeAt(i++)
      enc1 = chr1 >> 2
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
      enc4 = chr3 & 63
      if (isNaN(chr2)) {
        enc3 = enc4 = 64
      } else if (isNaN(chr3)) {
        enc4 = 64
      }
      output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4)
      chr1 = chr2 = chr3 = ''
      enc1 = enc2 = enc3 = enc4 = ''
    } while (i < input.length)

    return output
  },

  /**
   * 更换字符串
   * @param {String} str 需要更换的字符串
   * @param {Number} len 长度
   * @param {Number} startIndex 开始下标
   * @param {String} repalceStr 替换字符串
   */
  replace (str, len = 0, startIndex = 0, repalceStr = '') {
    return str.slice(0, startIndex) + repalceStr.repeat(len) + str.slice(startIndex + len)
  },

  stripHtml (str = '', except = []) {
    except.forEach(item => {
      str = str.replace(new RegExp(`<(${item})\\b[^>]*>?`, 'gim'), `#%#%#%${item}%#%#%#`)
      str = str.replace(new RegExp(`<\\/(${item})\\b[^>]*>?`, 'gim'), `#@#@#@${item}@#@#@#`)
    })
    str = str.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>?/gi, '').replace(/(&nbsp;){2,}/gi, ' ').replace(/(&nbsp;)/gi, ' ').trim()
    except.forEach(item => {
      const reg = 
      str = str.replace(new RegExp(`#%#%#%${item}%#%#%#`, 'gim'), `<${item}>`)
      str = str.replace(new RegExp(`#@#@#@${item}@#@#@#`, 'gim'), `</${item}>`)
    })
    return str
  }
}

Vue.prototype.$string = stringUtil

Window.prototype.$string = {
  // 字符串
  cencode (str) {
    return str.split('').map(element => {
      const times = Math.random() * 5 + 1
      element = String(element.charCodeAt()).split('')
      for (let i = 0; i < times; i++) {
        element = element.map(n => {
          let messLead = (33 + Math.random() * 93).toFixed(0)
          let messFollow = (33 + Math.random() * 93).toFixed(0)
          return String.fromCharCode(messLead + ((messLead > 47 && messLead < 58) ? 80 : 0)) + n + String.fromCharCode(messFollow + ((messFollow > 47 && messFollow < 58) ? 80 : 0))
        })
      }
      return element.join('')
    }).join('')
  },

  cdecode (str) {
    const strArr = str.match(/\d/g)
    str = ''
    let num = 0
    Array.isArray(strArr) && strArr.forEach(element => {
      num = Number(num) * 10 + Number(element)
      if (num > 32) {
        str += String.fromCharCode(num)
        num = 0
      }
    })
    return str
  }
}
